export class DocumentService
{

	static downloadDocument = (id: string) => {

		window.open(`/api/documents/${id}/download`);
	};

	static deleteDocument = (id: string) => {
		return fetch(`/api/documents/${id}`, {
			method: "DELETE"
		});
	};

}
